var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuestSession(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E8EAF0",
    cx: 138.6,
    cy: 18.1,
    r: 17.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M183.6,87c-3.7-6.9-19.7-36.2-20.3-36.8c-1.6-3.1-25.3-19-47.7-1.6c-1.2,0.6-0.3,0-20.6,16.5l-19.3-4.4 L71,71.9c0.9,0.6,0,0.3,24,5.6c1.9,0.3,3.7,0,5-1.2l14.4-11.9l4.4,56.8c0,0.9,0.3,1.6,0.9,2.2l-5.6,66.8c-0.3,5,3.1,9.4,8.1,9.7 c5,0.3,9.4-3.4,9.7-8.1l5.3-66.1l5.3,66.1c0.3,5,4.7,8.4,9.7,8.1c5-0.3,8.4-4.7,8.1-9.7l-5.3-65.8c1.2-0.3,2.5-1.6,2.5-2.8 l0.9-10.9c-3.1,0.6-7.2-0.9-9-4.4c-2.5-4.4-0.9-9.7,3.1-12.2l7.5-4.4l1.2-17.2c0.3,0.3,8.7,15.9,8.1,15c-0.3,0.3-16.5,9.7-15.6,9 c-2.8,1.6-3.7,5.3-2.2,8.1c1.5,2.8,5.6,3.7,8.1,2.2l20.6-11.9C184.2,93.6,185.1,89.9,183.6,87L183.6,87z M145.2,49.6l-2.8,8.7h-8.1 l-2.8-8.7C135.5,46.8,139.9,46.5,145.2,49.6z M134.3,61.1h8.7l2.2,30.9l-6.6,8.4l-6.9-8.4L134.3,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M36.3,36.2c9,0,18.4-6.6,18.4-18.1C54.7,8.1,46.6,0,36.6,0c-10,0.3-17.8,8.4-17.8,18.4 C18.8,28.1,26.6,36.2,36.3,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M31.6,123.5h0.3l-0.3-0.3c-0.9-1.2-1.9-2.8-1.9-4.7c-3.7-28.4-1.6-56.8-1.6-58c0.3-5,4.7-8.7,9.7-8.4 c5,0.3,8.7,4.7,8.4,9.7c0,0.3-1.9,27.8,1.2,54.6v0.6c0,2.5-0.6,4.7-2.2,6.2c1.9,0.3,3.4,1.2,4.1,2.8c9-9,3.7-17.5,5.3-69.3 c0-10-8.1-17.8-17.8-17.8C26.8,39.2,18.7,47,18.7,57v56.8c0,6.2,3.1,11.9,8.1,15C27.3,126.4,29.1,124.2,31.6,123.5L31.6,123.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M27.9,190.6c-0.3,5,3.4,9,8.4,9.4h0.6c4.7,0,8.7-3.7,9-8.4l1.2-23.1H29.4L27.9,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M37.6,55.2c-3.4-0.3-6.2,2.2-6.2,5.6c0,1.2-2.2,29.3,1.6,57.4v0.3c1.6,7.5,12.8,5.6,11.9-1.9 c-2.5-18.7-2.2-46.2-1.2-55.2C43.2,58.3,40.7,55.5,37.6,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M59.7,132.6h-6.2V165h6.2c0.9,0,1.6-0.6,1.6-1.6v-29.3C61.6,133.5,60.6,132.6,59.7,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M15.7,134.2v29.3c0,0.9,0.6,1.6,1.6,1.6h6.2v-32.4h-6.2C16.3,132.6,15.7,133.5,15.7,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M46.9,132.6c0-0.3,0-3.4,0-3.1c0-1.6-1.2-2.8-2.8-2.8H32.9c-1.6,0-2.8,1.2-2.8,2.8c0,0.3,0,3.4,0,3.1h-2.2 h-0.3V165h21.8v-32.4h-0.6H46.9z M32.6,129.5c0-0.3,0.3-0.3,0.3-0.3h11.2c0.3,0,0.3,0.3,0.3,0.3v0.3v2.8H32.6 C32.6,132.3,32.6,129.2,32.6,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M74.4,54.6l-6.6-14.4c1.2,7.2-5.6,23.4-5.6,23.4C65,70.8,64.7,78,64.7,78C80.9,39,62.5,83.3,74.4,54.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestSession);
export default __webpack_public_path__ + "static/media/guest-session.22e61722e68bf35512f029d9b2e7dd8e.svg";
export { ForwardRef as ReactComponent };